import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RenderJob } from '../render-flow.model';
import { RenderFlowService } from '../render-flow.service';
import { RENDER_OUTPUT_SPEC, renderDimensions } from '../render.data';
import { RenderStepBase } from './render-step-base';

interface DownloadCard {
  key: 'landscape' | 'portrait';
  label: string;
  dimensions: string;
  video: string;
  poster?: string;
}

// Step 3: both videos to watch, and beside them "Optimize for platforms" (render-pack-card, Figma
// 28563:27840, 2026-09-24) — the one way to download. The cards had their own download buttons
// until the designer left every file to the table (2026-09-25).
@Component({
  selector: 'app-render-downloads-step',
  templateUrl: './render-downloads-step.component.html',
})
export class RenderDownloadsStepComponent extends RenderStepBase {
  @HostBinding('class') public readonly hostClass = 'render-step step-downloads';

  public readonly fps = RENDER_OUTPUT_SPEC.fps;
  public readonly codec = RENDER_OUTPUT_SPEC.codec;
  public cards: DownloadCard[] = [];
  // The model whose videos the product analytics have seen opened.
  private counted = '';

  constructor(route: ActivatedRoute, router: Router, flow: RenderFlowService) {
    super(route, router, flow);
  }

  protected override onJob(job: RenderJob): void {
    this.cards = (['landscape', 'portrait'] as const).map((key) => ({
      key,
      label: key === 'landscape' ? 'Landscape' : 'Portrait',
      dimensions: renderDimensions(key),
      video: job.videos?.[key] || '',
      poster: job.preview?.[key],
    }));
    if (this.counted !== job.modelId && job.videos) {
      this.counted = job.modelId;
      this.flow.track('videos_viewed', job);
    }
  }

  public trackByKey(index: number, card: DownloadCard): string {
    return card.key;
  }
}
